// extracted by mini-css-extract-plugin
export var deliveryRow = "_kw-a";
export var fixedHeight = "_kw-4";
export var freightLogo = "_kw-9";
export var fullWidth = "_kw-3";
export var priceColumn = "_kw-5";
export var radioSelected = "_kw-7";
export var radioUnselected = "_kw-6";
export var selectedOption = "_kw-2";
export var selectedOptionContainer = "_kw-1";
export var selection = "_kw-0";
export var tallSkeletonText = "_kw-8";